export function animationOnScroll() {
    const $window = $(window);
    let $items = $(".has-animation");
    let duration;

    $window.on("scroll load", function () {
        $items.each(function (i, it) {
            if ($window.scrollTop() > $(it).offset().top - $window.height() * 0.88 && !$(it).hasClass("animate")) {
                $(it).addClass("animate");
                if ($(it).find(".number")) {
                    let number = $(it).find(".number span");
                    duration = number.data("speed");
                    $(it).prop('Counter', 0).animate({
                        Counter: number.text()
                    }, {
                        duration: duration,
                        easing: 'swing',
                        step: function (now) {
                            number.text(Math.ceil(now));
                        }
                    });
                }
            }
        });
    });

}


// WEBPACK FOOTER //
// ./assets/js/modules/animationOnScroll.js